import { createAsyncThunk } from "@reduxjs/toolkit";
import { db } from "../../../firebase/config";
import { TalesParagraph } from "../../../utils/types/TalesParagraph";
import firebase from "firebase";
import FieldPath = firebase.firestore.FieldPath;

export const toggleHighlightVisibility = createAsyncThunk(
  "highlight/toggleVisibility",
  async (highlight: TalesParagraph) => {
    try {
      const querySnapshot = await db
        .collection("highlight")
        .where("content", "==", highlight.content)
        .get();

      return querySnapshot.docs[0].ref.set({
        ...highlight,
        show: !highlight.show,
      });
    } catch (e: any) {
      console.log(e);

      return Promise.reject(
        `Highlight non ${highlight.show ? "nascosta" : "mostrata"}, ${e.message}`,
      );
    }
  },
);
